export default __webpack_public_path__ + "static/media/youth-group.393ecefe.jpg";